import api from './client';

export interface Plan {
  id: number;
  slug: string;
  name: string;
  description: string;
  price_monthly: number;
  price_yearly: number;
  price_monthly_display: string;
  price_yearly_display: string;
  savings_pct: number;
  limits: Record<string, number>;
  features: string[];
  is_free: boolean;
  is_available_for_signup: boolean;
  is_current: boolean;
  sort_order: number;
}

export interface BillingCharge {
  id: number;
  shopify_charge_id: number;
  plan_id: number;
  status: 'pending' | 'active' | 'declined' | 'cancelled';
  status_label: string;
  is_active: boolean;
  trial_days: number;
  test: boolean;
  confirmation_url: string | null;
  billing_on: string | null;
  activated_at: string | null;
  cancelled_at: string | null;
}

export const plansApi = {
  list: () => api.get<{ data: Plan[] }>('/plans'),
};

export const billingApi = {
  status: () => api.get<{ data: BillingCharge | null }>('/billing/status'),

  subscribe: (planId: number, host: string | null) =>
    api.post<{ data: { confirmation_url: string } }>('/billing/subscribe', { plan_id: planId, host }),

  activate: (chargeId: number) =>
    api.post<{ data: BillingCharge }>('/billing/activate', { charge_id: chargeId }),

  cancel: () => api.delete<{ data: null }>('/billing/cancel'),
};
